import { render } from "./Meal.vue?vue&type=template&id=ca3b1892&scoped=true"
import script from "./Meal.vue?vue&type=script&lang=js"
export * from "./Meal.vue?vue&type=script&lang=js"

import "./Meal.vue?vue&type=style&index=0&id=ca3b1892&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca3b1892"]])

export default __exports__